import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wallet, CalendarRange, BookOpenCheck, Home, Package } from 'lucide-react';
import { STR_PROPERTIES, strBasePath } from '../features/shortTermRentals/properties';

const ShortTermRentalsHub = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h1 style={{ color: '#1e293b', marginBottom: '20px' }}>Short Term Rentals</h1>
      <p style={{ color: '#64748b', marginBottom: '40px' }}>Select a property, or see all properties together below.</p>

      <div style={gridStyle}>
        {STR_PROPERTIES.map((property) => (
          <div
            key={property.key}
            onClick={() => navigate(strBasePath(property))}
            style={{ ...cardStyle, backgroundColor: property.color, border: `1px solid ${property.color}` }}
            className="hover-card"
          >
            <div style={{ ...iconBoxStyle, backgroundColor: 'rgba(255, 255, 255, 0.18)' }}>
              <Home size={32} color="white" />
            </div>
            <h3 style={{ margin: '15px 0 10px', color: 'white' }}>{property.name}</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '14px', lineHeight: '1.6' }}>
              {property.statusLabel || 'Manage financials, planning, pricing, bookings and cleaning.'}
            </p>
          </div>
        ))}
      </div>

      <h2 style={{ color: '#1e293b', fontSize: '20px', margin: '40px 0 20px' }}>All properties</h2>

      <div style={gridStyle}>
        <div onClick={() => navigate('/short-term-rentals/financials')} style={cardStyle} className="hover-card">
          <div style={{ ...iconBoxStyle, backgroundColor: '#ecfdf5' }}>
            <Wallet size={32} color="#059669" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Financials</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Income and expenses of all properties, with a filter for each one.
          </p>
        </div>

        <div onClick={() => navigate('/short-term-rentals/planning')} style={cardStyle} className="hover-card">
          <div style={{ ...iconBoxStyle, backgroundColor: '#eff6ff' }}>
            <CalendarRange size={32} color="#2563eb" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Planning</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Reservations of all properties on one calendar, with a filter for each one.
          </p>
        </div>

        <div onClick={() => navigate('/short-term-rentals/bookings')} style={cardStyle} className="hover-card">
          <div style={{ ...iconBoxStyle, backgroundColor: '#fef3c7' }}>
            <BookOpenCheck size={32} color="#d97706" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Bookings</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Bookings of all properties in one list, with a filter for each one.
          </p>
        </div>

        <div onClick={() => navigate('/short-term-rentals/inventory')} style={cardStyle} className="hover-card">
          <div style={{ ...iconBoxStyle, backgroundColor: '#fff7ed' }}>
            <Package size={32} color="#ea580c" />
          </div>
          <h3 style={{ margin: '15px 0 10px', color: '#1e293b' }}>Inventory</h3>
          <p style={{ color: '#64748b', fontSize: '14px', lineHeight: '1.6' }}>
            Items of all properties in one list, with a filter for each one.
          </p>
        </div>
      </div>
    </div>
  );
};

const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' };
const cardStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)', cursor: 'pointer', transition: 'all 0.2s ease', border: '1px solid #e2e8f0', height: '100%', boxSizing: 'border-box' };
const iconBoxStyle = { width: '56px', height: '56px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px' };

export default ShortTermRentalsHub;
